// LocalizedDateTimePicker.tsx
import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';

import 'dayjs/locale/en';
import 'dayjs/locale/pl';
import 'dayjs/locale/uk';
import 'dayjs/locale/ro';
import 'dayjs/locale/ru';

interface LocalizedDateTimePickerProps extends DateTimePickerProps {
}

export const LocalizedDateTimePicker: React.FC<LocalizedDateTimePickerProps> = (props: LocalizedDateTimePickerProps) => {
  const { i18n } = useTranslation();
  
  return (
    <LocalizationProvider 
      dateAdapter={AdapterDayjs} 
      adapterLocale={i18n.language} // Динамическая смена языка (ru, en, etc.)
    >
      <DateTimePicker
        format="L LT"
        {...props}
        slotProps={{ 
          // Скрываем панель действий
          actionBar: {
            actions: [], // Пустой массив убирает все кнопки
          },
          textField: { 
            size: "small", 
            fullWidth: true 
          },

        }}
      />
    </LocalizationProvider>
  );
};